module.exports = __webpack_public_path__ + "3c29d286fc33c834eb2f801d8880ae96.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-6.png
// module id = 135
// module chunks = 0